import { ModelService } from './ModelService';
import { Instance } from '../../model/Instance';
import { IInstanceService } from '../IInstanceService';

export class InstanceService extends ModelService<Instance> implements IInstanceService {
}